import { Emitter, Event } from "../../../../features/event-emitter"
import { TableName } from "../../../../tables"
import { PaymentStatus } from "../../../operations"
import { RoutePath, useRoutesHooks } from "../../../../features/routes"
import { useSaleOperationLoaders } from "../../loaders/saleOperationLoaders"
import { useSaleOperationService } from "../../services/sale-operation-service/saleOperationService"
import { PendingFinancialDelivery, useHoardService } from "../../services/hoardService"
import { SalePaymentItemData } from "../../services/sale-operation-service/types"

export const useActions = () => {
    const saleOperationLoaders = useSaleOperationLoaders()
    const { getRoutePath } = useRoutesHooks()

    const { confirmSalePayment } = useSaleOperationService()
    const { increaseHoardValue, emitFinancialDeliveryOrder } = useHoardService()

    const validatePaymentStatus = async (
        table: TableName,
        operationId: string,
        paymentStatus: PaymentStatus
    ) => {
        const { loadSaleOperation } = saleOperationLoaders()
        const loadedOperation = await loadSaleOperation(table, operationId, true)
        if (loadedOperation!.paymentStatus !== paymentStatus) {
            return 'El estado de pago de la operación cambió desde que se cargó la información. Volver al detalle de la operación con la información actualizada.'
        }
    }

    const submitPayment = async (
        table: TableName,
        operationId: string,
        paymentDate: Date,
        salePaymentItems: SalePaymentItemData[],
        increaseAmount?: number,
        amountToPay?: number,
        pendingDelivery?: PendingFinancialDelivery
    ) => {
        if (increaseAmount) {
            // La ampliación del acopio se guarda junto con el cobro, para que no quede ampliado sin cobrar.
            // Si viene de una entrega que superó el crédito, se emite ahora (y la entrega amplía el acopio)
            if (pendingDelivery) {
                await emitFinancialDeliveryOrder(operationId, pendingDelivery.deliveryOrderData, pendingDelivery.itemsData)
            } else {
                await increaseHoardValue(operationId, increaseAmount)
            }
            await confirmSalePayment(table, operationId, paymentDate, salePaymentItems, amountToPay)
            // Se vuelve al detalle del acopio (atrás está el formulario de ampliación)
            Emitter.emit(Event.DB_SUBMIT_DONE, false, false, getRoutePath(RoutePath.HOARDS, operationId))
        } else {
            await confirmSalePayment(table, operationId, paymentDate, salePaymentItems)
            Emitter.emit(Event.DB_SUBMIT_DONE, false)
        }
    }
    
    return {
        validatePaymentStatus,
        submitPayment
    }
}
